import type { SxProps, Theme } from '@mui/material';

/** Matches `labelSx` in ReservationEditDetailsSection (LabelRow / FullWidthRow). */
export const reservationEditFieldLabelSx: SxProps<Theme> = {
    fontWeight: 800,
    color: 'text.secondary',
    lineHeight: 1.35,
};

/** Typography for values and input text (read-only + typed content). */
export const reservationEditFieldValueSx: SxProps<Theme> = {
    color: 'text.primary',
    lineHeight: 1.35,
};

/**
 * Scoped styles for form fields so labels and outlined inputs match
 * ReservationEditDetailsSection (label weight/color + input body + borders).
 */
export function reservationRequestFormFieldsSx(theme: Theme): SxProps<Theme> {
    const body2FontSize = theme.typography.body3.fontSize ?? '0.875rem';
    const captionFontSize = theme.typography.caption.fontSize ?? '0.75rem';

    return {
        '& .MuiInputLabel-root': {
            fontWeight: 800,
            color: theme.palette.text.secondary,
            lineHeight: 1.35,
            fontSize: body2FontSize,
            '&.MuiInputLabel-shrink': {
                fontWeight: 800,
                color: theme.palette.text.secondary,
            },
        },
        '& .MuiInputBase-root': {
            fontSize: body2FontSize,
            lineHeight: 1.35,
            borderRadius: 1,
            backgroundColor: '#fff',
        },
        '& .MuiInputBase-input': {
            fontSize: body2FontSize,
            lineHeight: 1.35,
            color: theme.palette.text.primary,
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.custom.lightBorderColor,
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.custom.lightBorderColor,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
            {
                borderColor: theme.palette.primary.main,
                borderWidth: 1,
            },
        '& .MuiAutocomplete-input': {
            fontSize: body2FontSize,
            lineHeight: 1.35,
        },
        '& .MuiFormHelperText-root': {
            fontSize: captionFontSize,
            lineHeight: 1.35,
            marginTop: theme.spacing(0.5),
        },
        '& .MuiChip-label': {
            fontSize: body2FontSize,
            lineHeight: 1.35,
        },
        '& .MuiFormControlLabel-label': {
            fontSize: body2FontSize,
            lineHeight: 1.35,
            color: theme.palette.text.primary,
        },
    };
}
